import { createFileRoute, redirect } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { z } from "zod";
import {
  HeaderRoot,
  HeaderButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { OneLivSocialMediaForm } from "@/components/oneliv/oneliv-social-media-form";

import type { JSX } from "react";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetOneLivUserSocialMedia = graphql(`
  query GetOneLivUserSocialMedia {
    ...OneLivSocialMediaFormFragment
  }
`);

const oneLivSocialMediaPageSearchSchema = z.object({
  action: z.string().optional().catch(""),
});

const OneLivSocialMedia = (): JSX.Element => {
  const query = useGraphQL(GetOneLivUserSocialMedia);

  const { data } = query;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Redes sociais" align="center" />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...query}>
          {data ? <OneLivSocialMediaForm data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/oneliv/social-media")({
  component: OneLivSocialMedia,
  validateSearch: oneLivSocialMediaPageSearchSchema,
  beforeLoad: ({ context }) => {
    const shouldDisplaySocialMediaPage =
      context.flags["deve-exibir-etapa-de-redes-socias-no-fluxo-do-one-liv-no-app"];

    if (!shouldDisplaySocialMediaPage) {
      redirect({
        to: "/oneliv/additional-info",
        throw: true,
      });
    }
  },
});
